
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import router from "@/router";
import { formattedTranslationValues } from "@/utils/misc";

@Component
export default class SubKeyCreate extends Vue {

    @Prop({default: null})
    public keyIdToDuplicate: number;

    @Getter private isMobile: boolean;

    private createSubKeyModalOne: boolean = true;
    private createSubKeyModalTwo: boolean = false;
    private createSubKeyLoading: boolean = false;
    private newSubKeys: any[] = [];
    private numberSubKeys: number = 1;
    private tags: Array<{text: string, value: number}> = [];
    private loadingTags: boolean = false;
    private categories: Array<{text: string, value: number}> = [];
    private loadingCategories: boolean = false;

    private mounted() {
      this.getTags();
      this.getCategories();
    }

    private reset(): void {
        this.$emit("close");
        this.newSubKeys = [];
        this.createSubKeyLoading = false;
    }

    private createSubKeys(): Promise<any> {
        this.createSubKeyLoading = true;
        return this.$store.dispatch("keys/createSubKeys", {
            keyId: this.keyIdToDuplicate,
            subKeys: this.newSubKeys,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                icon: "icon-picto_cle-partagees",
                msg: this.$i18n?.t("alerts.key.creationSuccess"),
            });
            this.$emit("created");
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.reset();
        });
    }

    private generateSubKeys(): void {
        for (let i = this.numberSubKeys; i > 0; i--) {
            this.addSubKey();
        }
        this.createSubKeyModalOne = false;
        this.createSubKeyModalTwo = true;
    }

    private addSubKey(): void {
        this.newSubKeys.push({
            keyName: "",
            category: null,
        });
    }

    private removeSubKey(k): void {
        this.newSubKeys.splice(k, 1);
    }

    private getTags(): void {
      this.loadingTags = true;
      this.$store.dispatch("tags/getAll", {
        query: {
          lang: this.$root.$i18n.locale,
        },
      })
        .then((res) => {
          this.tags = formattedTranslationValues(
            res,
            this.$root.$i18n.locale);
        })
        .finally(() => {
          this.loadingTags = false;
        });
    }

    private getCategories(): void {
      this.loadingCategories = true;
      this.$store.dispatch("categories/getAll")
        .then((res) => {
          this.categories = formattedTranslationValues(
            res.categories,
            this.$root.$i18n.locale);
        })
        .finally(() => {
          this.loadingCategories = false;
        });
    }
}
